import { PICKUP_POINT_COOKIE_MAX_AGE } from 'config/constants';
import { deleteCookie, getCookies, hasCookie, setCookie } from 'cookies-next';
import { PickupPointType } from 'types/pickupPoint';
import { TransportTypeCodeEnum } from 'types/transport';

const PICKUP_POINT_COOKIE_NAMES: Partial<Record<TransportTypeCodeEnum, string>> = {
    [TransportTypeCodeEnum.PACKETERY]: 'packeteryPickupPoint',
    [TransportTypeCodeEnum.PACZKOMAT]: 'paczkomatPickupPoint',
    [TransportTypeCodeEnum.BALIKOVNA]: 'balikovnaPickupPoint',
    [TransportTypeCodeEnum.PPL]: 'pplPickupPoint',
    [TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_CZ]: 'postOfficePickupPoint',
    [TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_HU]: 'postOfficeHuPickupPoint',
    [TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_SK]: 'postOfficeSkPickupPoint',
    [TransportTypeCodeEnum.PBH]: 'postOfficePbhPickupPoint',
    [TransportTypeCodeEnum.DPD]: 'dpdPickupPoint',
};

const getPickupPointCookieName = (transportCode: string, transportUuid: string): string | null => {
    const cookieName = PICKUP_POINT_COOKIE_NAMES[transportCode as TransportTypeCodeEnum];

    return cookieName ? `${cookieName}_${transportUuid}` : null;
};

export const getPickupPointCookie = (transportCode: string, transportUuid: string): PickupPointType | null => {
    const cookieName = getPickupPointCookieName(transportCode, transportUuid);
    const cookies = getCookies();

    if (!cookieName || !hasCookie(cookieName)) {
        return null;
    }

    const value = cookies[cookieName];

    if (!value) {
        return null;
    }

    try {
        return JSON.parse(decodeURIComponent(value));
    } catch {
        deleteCookie(cookieName, { path: '/' });

        return null;
    }
};

export const setPickupPointCookie = (
    pickupPoint: PickupPointType,
    transportCode: string,
    transportUuid: string,
): void => {
    const cookieName = getPickupPointCookieName(transportCode, transportUuid);

    if (!cookieName) {
        return;
    }

    setCookie(cookieName, JSON.stringify(pickupPoint), {
        path: '/',
        maxAge: PICKUP_POINT_COOKIE_MAX_AGE,
    });
};

export const removePickupPointCookies = (): void => {
    const cookies = getCookies();

    Object.keys(cookies).forEach((cookieName) => {
        if (Object.values(PICKUP_POINT_COOKIE_NAMES).some((name) => cookieName.startsWith(`${name}_`))) {
            deleteCookie(cookieName, { path: '/' });
        }
    });
};
